import type { SaveState } from './useAutoSave'

/** What autosave is doing, in the space the Save button used to take up. */
export function SaveStatus({ state, message }: { state: SaveState; message: string | null }) {
  if (state === 'blocked' || state === 'error') {
    return <span className="text-[12px] leading-tight text-danger">{message}</span>
  }
  if (state === 'pending' || state === 'saving') {
    return <span className="text-[12px] text-faint">Saving…</span>
  }
  if (state === 'saved') {
    return <span className="text-[12px] text-faint">Saved</span>
  }
  return null
}
